<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <!--breadcrumbs and title-->
            <div class="container">
                <component src="https://c2hbe361.caspio.com/dp/76bfd000aec87c7310e84ca7b0b5/emb" :is="'script'">
                </component>
            </div>

            <div class="flex-container">
                <div class="left-section">
                    <h2>FAQs</h2>
                    <hr class="h2" />
                    <!--FAQs table-->
                    <div class="container">
                        <component src="https://c2hbe361.caspio.com/dp/76bfd000372ab2365b924ace9cc8/emb" :is="'script'">
                        </component>
                    </div>
                    <!--FAQs submit button-->
                    <div class="container">
                        <component src="https://c2hbe361.caspio.com/dp/76bfd0001ded5fe6c4d3442db1a3/emb" :is="'script'">
                        </component>
                    </div>
                </div>
                <div class="right-section">
                    <!--Test agent-->
                    <div class="container">
                        <component src="https://c2hbe361.caspio.com/dp/76bfd000155ff238df2743998991/emb" :is="'script'">
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '../SideBar.vue'

export default {
    name: 'BotFAQs',
    components: {
        SideBar
    }
}
</script>

<style scoped>
.flex-container {
    display: flex;
    flex-direction: row;
}

.right-section {
    max-width: 420px;
}
</style>